export default __webpack_public_path__ + "static/media/organization.647eb627.svg";